/* eslint-disable-next-line no-restricted-imports -- needed for creating typed
 * hooks.
 * See https://redux.js.org/tutorials/typescript-quick-start#define-typed-hooks
 */
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'reducers/root';
import type { AppDispatch } from './store';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
